import { defaultClient } from '@mint-sdk/api-core';

import { VirtualPlatformsResponseSchema } from './schemas.js';

export const listQueryOptions = defaultClient.query({
  url: 'bff/v2/virtual-platforms/?cache=skip',
  method: 'GET',
  responseSchema: VirtualPlatformsResponseSchema,
  processResponse(data) {
    return data.data?.items ?? [];
  },
});
